import { render, staticRenderFns } from "./modelattr.vue?vue&type=template&id=b79e0182&scoped=true"
import script from "./modelattr.vue?vue&type=script&lang=js"
export * from "./modelattr.vue?vue&type=script&lang=js"
import style0 from "./modelattr.vue?vue&type=style&index=0&id=b79e0182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79e0182",
  null
  
)

export default component.exports